import { AuthenticatedTemplate } from "@azure/msal-react";
import "./index.scss";
import Hook from "./useOauthCallback";
import { PrimaryButton } from "@moneris-portal/button";
import errorIcon from "../../../assets/error_icon.svg";
import letterIcon from "../../../assets/letter_icon.svg";
import { OauthCallbackState } from "./constants";
import { CheckIcon } from "@moneris-portal/svg-components";

function QBO_OauthCallback(params) {
  const { BLOCK, translate, callbackState, handleButton } =
    Hook.useOauthCallback(params);
  return (
    <AuthenticatedTemplate>
      <div className={`${BLOCK.current}`}>
        <div className={`${BLOCK.current}__container`}>
          <div className={`${BLOCK.current}__icon-section loader_panel`}>
            {callbackState === OauthCallbackState.LOADING && (
              <div className={`${BLOCK.current}__loader spinner`} />
            )}
            {callbackState === OauthCallbackState.ERROR && (
              <img
                src={errorIcon}
                alt=""
                aria-hidden="true"
                className={`${BLOCK.current}__icon`}
              />
            )}
            {callbackState === OauthCallbackState.COMPLETE && (
              <div className={`${BLOCK.current}__check-icon`}>
                <CheckIcon />
              </div>
            )}
          </div>
          <div className={`${BLOCK.current}__state-section`}>
            <h2>
              {translate(`oauth-callback-state-${callbackState.toLowerCase()}`)}
            </h2>
            <p>
              {translate(
                `oauth-callback-state-${callbackState.toLowerCase()}-subtitle`,
              )}
            </p>
          </div>
          {callbackState === OauthCallbackState.COMPLETE && (
            <div className={`${BLOCK.current}__next-steps`}>
              <div className={`${BLOCK.current}__icon`}>
                <img
                  src={letterIcon}
                  alt=""
                  aria-hidden="true"
                  className={`${BLOCK.current}__letter-icon`}
                />
              </div>
              <div>
                <h2>{translate("oauth-callback-next-steps-title")}</h2>
                <p>{translate("oauth-callback-next-steps-message")}</p>
              </div>
            </div>
          )}
          {callbackState === OauthCallbackState.ERROR ||
          callbackState === OauthCallbackState.COMPLETE ? (
            <div className={`${BLOCK.current}__action`}>
              <PrimaryButton
                clickHandler={handleButton}
                title={translate(
                  `oauth-callback-action-button-${callbackState.toLowerCase()}`,
                )}
              />
            </div>
          ) : null}
        </div>
      </div>
    </AuthenticatedTemplate>
  );
}

export default QBO_OauthCallback;
